<template>
  <button class="mobile-choose-button" @click="$emit('click')">
    <p class="mobile-choose-icon-text">
      <component :is="iconComponent" class="previewModal--icon" />
      {{ label }}
    </p>
    <RightIcon />
  </button>
</template>

<script>
import Android from '@/assets/icons/svg/android-white.svg';
import Apple from '@/assets/icons/svg/apple-white.svg';
import RightIcon from '@/assets/icons/svg/right-icon-white.svg';

export default {
  name: 'MobileChooseButton',
  components: { Android, Apple, RightIcon },
  props: {
    label: String,
    icon: {
      type: String,
      required: true,
      validator: (value) => ['android', 'apple'].includes(value),
    },
  },
  computed: {
    iconComponent() {
      return this.icon === 'android' ? 'Android' : 'Apple';
    },
  },
};
</script>
